<template>
    <div class="cont-result-faq margin-general">
        <NuxtLink :to="localPath('/faq')" class="back-link">
            <span data-v-b04161ba="" class="material-symbols-outlined" translate="no">chevron_left</span>
            {{ $t("faq.goback") }}
        </NuxtLink>
        <div class="sub-cont">
            <FaqAccordion>
                <div class="accordeon container movil">
                    <div class="content-main-tab">
                        <div class="tab-content">
                            <div class="contet-general">
                                <h4 role="heading" aria-level="1">{{ $t("faq.tab3.title1") }}</h4>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">qr_code</span>
                                    <div class="list-number"><span>1.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span class="black" v-html="formatContent('faq.tab3.text1', $t, localPath)"></span></p>
                                        <p class="body-4"><span v-html="formatContent('faq.tab3.text2', $t, localPath)"></span></p>
                                        <p class="body-4"><span v-html="formatContent('faq.tab3.text2-1', $t, localPath)"></span></p>
                                        <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-07.jpg"><img src="/images/faq/New-user-guide-q2-07.jpg" alt="Imagen 1" class="responsive-image"></picture>
                                        <p class="body-4"><span v-html="formatContent('faq.tab3.text2-2', $t, localPath)"></span></p>
                                    <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q3-02.png"><img src="/images/faq/New-user-guide-q3-02.png" alt="Imagen 1" class="responsive-image"></picture>
                                    </div>
                                    </div>
                                </div>
                                <!-- <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">variable_insert</span>
                                    <div class="list-number"><span>2.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span class="black" v-html="formatContent('faq.tab3.text3', $t, localPath)"></span></p>
                                        <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q3-01.png"><img src="/images/faq/New-user-guide-q3-01.png" alt="Imagen 1" class="responsive-image"></picture>
                                        <p class="body-4"><span >{{ $t("faq.tab3.text4") }}</span></p>
                                        <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q3-02.png"><img src="/images/faq/New-user-guide-q3-02.png" alt="Imagen 1" class="responsive-image"></picture>
                                        <p class="body-4"><span >{{ $t("faq.tab3.text5") }}</span></p>
                                        <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q3-04.png"><img src="/images/faq/New-user-guide-q3-04.png" alt="Imagen 1" class="responsive-image"></picture>
                                        <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q3-05-movil.png"><img src="/images/faq/New-user-guide-q3-05.png" alt="Imagen 1" class="responsive-image"></picture>
                                        <p class="body-4"><span >{{ $t("faq.tab3.text6") }}</span></p>
                                    </div>
                                    </div>
                                </div> -->
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">arrow_upload_ready</span>
                                    <div class="list-number"><span>2.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span class="black" v-html="formatContent('faq.tab3.text7', $t, localPath)"></span></p>
                                        <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q3-03.png"><img src="/images/faq/New-user-guide-q3-03.png" alt="Imagen 1" class="responsive-image"></picture>
                                        <p class="body-4"><span >{{ $t("faq.tab3.text8") }}</span></p>
                                        <p class="body-4"><span v-html="formatContent('faq.tab3.text8-1', $t, localPath)"></span></p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">camera_front</span>
                                    <div class="list-number"><span>3.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span class="black" v-html="formatContent('faq.tab3.text9', $t, localPath)"></span></p>
                                        <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q3-04.png"><img src="/images/faq/New-user-guide-q3-04.png" alt="Imagen 1" class="responsive-image"></picture>
                                        <p class="body-4"><span class="black" v-html="formatContent('faq.tab3.text10', $t, localPath)"></span></p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-general">
                                        <div class="sub-cont">
                                            <p class="body-4"><span >{{ $t("faq.tab3.text11") }}</span></p>
                                            <a :href="getExternalUrl('/login')" target="_blank" rel="noopener noreferrer">
                                                <button class="primary-button-medium">
                                                    {{ $t("faq.tab3.btn") }}
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FaqAccordion>
            <div class="accordeon container destock">
                <div class="content-main-tab">
                    <div class="tab-content">
                        <div class="contet-general">
                            <h1>{{ $t("faq.tab3.title1") }}</h1>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">qr_code</span>
                                <div class="list-number"><span>1.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span class="black" v-html="formatContent('faq.tab3.text1', $t, localPath)"></span></p>
                                    <p class="body-4"><span v-html="formatContent('faq.tab3.text2', $t, localPath)"></span></p>
                                    <p class="body-4"><span v-html="formatContent('faq.tab3.text2-1', $t, localPath)"></span></p>
                                    <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-05.png"><img src="/images/faq/New-user-guide-q2-05.png" alt="Imagen 1" class="responsive-image"></picture>
                                    <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q2-05.png"><img src="/images/faq/New-user-guide-q2-07.jpg" alt="Imagen 1" class="responsive-image"></picture>
                                    <p class="body-4"><span v-html="formatContent('faq.tab3.text2-2', $t, localPath)"></span></p>
                                    <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q3-02.png"><img src="/images/faq/New-user-guide-q3-02.png" alt="Imagen 1" class="responsive-image"></picture>
                                </div>
                                </div>
                            </div>
                            <!-- <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">variable_insert</span>
                                <div class="list-number"><span>2.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span class="black" v-html="formatContent('faq.tab3.text3', $t, localPath)"></span></p>
                                    <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q3-01.png"><img src="/images/faq/New-user-guide-q3-01.png" alt="Imagen 1" class="responsive-image"></picture>
                                    <p class="body-4"><span >{{ $t("faq.tab3.text4") }}</span></p>
                                    <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q3-02.png"><img src="/images/faq/New-user-guide-q3-02.png" alt="Imagen 1" class="responsive-image"></picture>
                                    <p class="body-4"><span >{{ $t("faq.tab3.text5") }}</span></p>
                                    <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q3-04.png"><img src="/images/faq/New-user-guide-q3-04.png" alt="Imagen 1" class="responsive-image"></picture>
                                    <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q3-05-movil.png"><img src="/images/faq/New-user-guide-q3-05.png" alt="Imagen 1" class="responsive-image"></picture>
                                    <p class="body-4"><span >{{ $t("faq.tab3.text6") }}</span></p>
                                </div>
                                </div>
                            </div> -->
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">arrow_upload_ready</span>
                                <div class="list-number"><span>2.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span class="black" v-html="formatContent('faq.tab3.text7', $t, localPath)"></span></p>
                                    <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q3-03.png"><img src="/images/faq/New-user-guide-q3-03.png" alt="Imagen 1" class="responsive-image"></picture>
                                    <p class="body-4"><span v-html="formatContent('faq.tab3.text8', $t, localPath)"></span></p>
                                    <p class="body-4"><span v-html="formatContent('faq.tab3.text8-1', $t, localPath)"></span></p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">camera_front</span>
                                <div class="list-number"><span>3.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span class="black" v-html="formatContent('faq.tab3.text9', $t, localPath)"></span></p>
                                    <picture class="min-image-desktop"><source media="(max-width: 570px)" srcset="/images/faq/New-user-guide-q3-04.png"><img src="/images/faq/New-user-guide-q3-04.png" alt="Imagen 1" class="responsive-image"></picture>
                                    <p class="body-4"><span class="black" v-html="formatContent('faq.tab3.text10', $t, localPath)"></span></p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span >{{ $t("faq.tab3.text11") }}</span></p>
                                        <a :href="getExternalUrl('/login')" target="_blank" rel="noopener noreferrer">
                                            <button class="primary-button-medium">
                                                {{ $t("faq.tab3.btn") }}
                                            </button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script setup>
import { useExternalUrl } from '@/composables/useExternalUrl';
const { getExternalUrl } = useExternalUrl();

const { t, locale } = useI18n();
const route = useRoute();
const localPath = useLocalePath();
import FaqAccordion from '~/components/faq/FaqAccordion.vue'

useFaqSeoMeta("faq.tab3.title1", "faq.tab3.text1");
</script>


